<div class="overlay"></div>
<div class="modal-signup">
    <div class="logo-container">
        <img src="../../../assets/login/logo.png" alt="Datacore Logo" />
        <button class="close-btn" (click)="close()">✕</button>
    </div>

    <div class="modal-body">
        <div class="header">
            <h2>{{ 'profileSetup.title' | translate }}</h2>
            <p>
                {{ 'profileSetup.description' | translate }}
            </p>
        </div>

        <form class="form">
            <div class="checkbox">
                <label>
                    <input
                        type="checkbox"
                        [(ngModel)]="isProfessional"
                        name="isProfessional"
                    />
                    <span
                        >{{ 'profileSetup.professional.checkbox' | translate }}</span
                    >
                </label>
            </div>

            <div *ngIf="isProfessional" class="professional-section">
                <label>{{ 'profileSetup.professional.company' | translate }}<span class="error">*</span></label>
                <nz-select
                    nzShowSearch
                    [(ngModel)]="company"
                    class="custom-nz-select"
                    required
                    name="company"
                >
                    <nz-option
                        *ngFor="let opt of companies"
                        [nzLabel]="lang === 'vi' ? opt.nameVn : opt.nameEn"
                        [nzValue]="opt.nameEn"
                    >
                    </nz-option>
                </nz-select>

                <div *ngIf="company == 'Other'" class="custom-input-group">
                    <label class="input-label">{{ 'profileSetup.professional.otherLabel' | translate }}</label>

                    <div class="input-wrapper">
                        <div class="input-prefix">{{ 'profileSetup.professional.other' | translate }}</div>

                        <input
                            [(ngModel)]="otherCompany"
                            type="text"
                            class="input-field"
                            placeholder="{{ 'profileSetup.professional.otherPlaceholder' | translate }}"
                            name="otherCompany"
                        />

                        <button type="button" class="clear-btn">✖</button>
                    </div>
                </div>

                <label>{{ 'profileSetup.professional.organizationEmail' | translate }}<span class="error">*</span></label>
                <input
                    type="email"
                    placeholder="{{ 'profileSetup.professional.organizationEmailPlaceholder' | translate }}"
                    [(ngModel)]="organizationEmail"
                    name="organizationEmail"
                    [required]="isProfessional"
                    pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                    #organizationEmailRef="ngModel"
                />
                <div
                    class="error"
                    *ngIf="
                        (submitted || organizationEmailRef.touched) &&
                        organizationEmailRef.invalid
                    "
                >
                    <div *ngIf="organizationEmailRef.errors?.required">
                        {{ 'profileSetup.professional.organizationEmailRequired' | translate }}
                    </div>
                    <div *ngIf="organizationEmailRef.errors?.pattern">
                        {{ 'profileSetup.professional.organizationEmailInvalid' | translate }}
                    </div>
                </div>

                <label>{{ 'profileSetup.professional.profileUrl' | translate }}<span class="error">*</span></label>
                <input
                    type="url"
                    placeholder="{{ 'profileSetup.professional.profileUrlPlaceholder' | translate }}"
                    [(ngModel)]="linkedinUrl"
                    name="linkedinUrl"
                    [required]="isProfessional"
                    #linkedinUrlRef="ngModel"
                    pattern="^(https?://).*$"
                />
                <div
                    class="error"
                    *ngIf="
                        (submitted || linkedinUrlRef.touched) &&
                        linkedinUrlRef.invalid
                    "
                >
                    <div *ngIf="linkedinUrlRef.errors?.required">
                        {{ 'profileSetup.professional.profileUrlRequired' | translate }}
                    </div>
                    <div *ngIf="linkedinUrlRef.errors?.pattern">
                        {{ 'profileSetup.professional.profileUrlInvalid' | translate }}
                    </div>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col">
                    <label>{{ 'profileSetup.username.label' | translate }}<span class="error">*</span></label>
                    <input
                        type="text"
                        placeholder="{{ 'profileSetup.username.placeholder' | translate }}"
                        [(ngModel)]="username"
                        (ngModelChange)="userNameChange()"
                        name="username"
                        minlength="2"
                        maxlength="50"
                        #usernameRef="ngModel"
                        required
                    />
                    <div
                        class="error"
                        *ngIf="
                            (submitted || usernameRef.touched) &&
                            usernameRef.invalid
                        "
                    >
                        <div *ngIf="usernameRef.errors?.required">
                            {{ 'profileSetup.username.required' | translate }}
                        </div>
                        <div *ngIf="usernameRef.errors?.minlength">
                            {{ 'profileSetup.username.minlength' | translate }}
                        </div>
                        <div *ngIf="usernameRef.errors?.maxlength">
                            {{ 'profileSetup.username.maxlength' | translate }}
                        </div>
                        <div *ngIf="usernameRef.errors?.pattern">
                            {{ 'profileSetup.username.pattern' | translate }}
                        </div>
                    </div>
                    <div *ngIf="usernameError" class="error">
                        {{ 'profileSetup.username.exists' | translate }}
                    </div>
                </div>
            </div> -->

            <label>{{ 'profileSetup.password.label' | translate }}<span class="error">*</span></label>
            <div class="password-wrapper">
                <input
                    [type]="showPassword ? 'text' : 'password'"
                    placeholder="{{ 'profileSetup.password.placeholder' | translate }}"
                    [(ngModel)]="password"
                    name="password"
                    #passwordRef="ngModel"
                    required
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$"
                    minlength="8"
                />
                <button type="button" class="toggle" (click)="togglePassword()">
                    <i
                        [ngClass]="
                            showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'
                        "
                    ></i>
                </button>
            </div>
            <div
                class="error"
                *ngIf="
                    (submitted || passwordRef.touched) && passwordRef.invalid
                "
            >
                <div *ngIf="passwordRef.errors?.required">
                    {{ 'profileSetup.password.required' | translate }}
                </div>
                <div *ngIf="passwordRef.errors?.pattern">
                    {{ 'profileSetup.password.pattern' | translate }}
                </div>
                <div *ngIf="passwordRef.errors?.minlength">
                    {{ 'profileSetup.password.minlength' | translate }}
                </div>
            </div>

            <label>{{ 'profileSetup.confirmPassword.label' | translate }}<span class="error">*</span></label>
            <div class="password-wrapper">
                <input
                    [type]="showConfirmPassword ? 'text' : 'password'"
                    placeholder="{{ 'profileSetup.confirmPassword.placeholder' | translate }}"
                    [(ngModel)]="confirmPassword"
                    name="confirmPassword"
                    #confirmPasswordRef="ngModel"
                    required
                    pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$"
                    minlength="8"
                />
                <button
                    type="button"
                    class="toggle"
                    (click)="toggleConfirmPassword()"
                >
                    <i
                        [ngClass]="
                            showConfirmPassword
                                ? 'fa fa-eye-slash'
                                : 'fa fa-eye'
                        "
                    ></i>
                </button>
            </div>
            <div
                class="error"
                *ngIf="
                    (submitted || confirmPasswordRef.touched) &&
                    confirmPasswordRef.invalid
                "
            >
                <div *ngIf="confirmPasswordRef.errors?.required">
                    {{ 'profileSetup.confirmPassword.required' | translate }}
                </div>
                <div *ngIf="confirmPasswordRef.errors?.pattern">
                    {{ 'profileSetup.confirmPassword.pattern' | translate }}
                </div>
                <div *ngIf="confirmPasswordRef.errors?.minlength">
                    {{ 'profileSetup.confirmPassword.minlength' | translate }}
                </div>
            </div>
        </form>
        <button class="finish-button" [class.disable]="!isFormValid()" [disabled]="!isFormValid()" (click)="onSubmit()">{{ 'profileSetup.actions.next' | translate }}</button>
    </div>
</div>
